import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import cn from 'classnames'
import { makeStyles } from '@material-ui/core'
import * as Constants from 'out-game/constants'
import { Color, Routes } from 'out-game/constants'
import ImgVisa from 'out-game/images/visa.svg'
import ImgMir from 'out-game/images/mir.svg'
import ImgMasterCard from 'out-game/images/mastercard.svg'
import ImgWebMoney from 'out-game/images/WebMoneyNew.svg'
import ImgQiwi from 'out-game/images/QiwiFooter.svg'
import ImgYooMoney from 'out-game/images/YooMoney.svg'
import Payu from 'out-game/images/payu.svg'
import imgFindexiq from 'out-game/images/findexiq.svg'
import {
  Link,
  Menu,
  MenuItem,
  SocialNetworks,
  Typography,
} from 'out-game/components'
import { useRequestCountryCode } from '../hooks/useRequest'
import ButtonRestyled from '../components/ButtonRestyled'
import { useTranslationStrict } from 'out-game/hooks'
import { isLanguage, Language as TranslationLanguage } from './types'

const useStyles = makeStyles({
  root: {
    '& .og-link': {
      textDecoration: 'none',
    },
  },
  top: {
    gridArea: 'top',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rights: {
    gridArea: 'rights',
    marginBottom: 5,
  },
  support: {
    textAlign: 'right',
    gridArea: 'support',
  },
  payment: {
    gridArea: 'payment',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  payment_eng: {
    justifyContent: 'center',
  },
  underlineHover: {
    '&:not(:hover)': {
      borderBottomStyle: 'solid',
      borderWidth: 2,
      borderColor: 'transparent',
    },
    '&:hover': {
      borderBottomStyle: 'solid',
      borderWidth: 2,
      borderColor: Color.Primary,
    },
  },
  underlineContainer: {
    height: 42,
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  seoText: {
    maxWidth: '1194px',
    margin: '0 auto',

    '&>p': {
      margin: '13px 0',
    },
  },
})

enum Language {
  rus = 'RUS',
  eng = 'ENG',
}

type ContactsLocales = {
  name: string
  number: string
  address: string
  stateRegNumber?: string
} | null

const RegistrationInfo: React.FC = () => {
  const classes = useStyles()
  const {
    t,
    i18n: { language },
  } = useTranslationStrict('contacts')

  return (
    <Typography size={12} weight="lighter" className={classes.rights}>
      {t('name')}
      {language === 'ru' && t('stateRegNumber') && (
        <>
          <br />
          {t('stateRegNumber')}
        </>
      )}
      <br />
      {t('number')}
      <br />
      {t('address')}
    </Typography>
  )
}

const Footer: React.FC = () => {
  const {
    t,
    i18n: { language },
  } = useTranslationStrict('footer')

  if (!isLanguage(language)) {
    throw new Error('Unexpected language code')
  }

  const isEnglish = language === TranslationLanguage.eng

  const classes = useStyles()
  const history = useHistory()

  return (
    <footer className={cn(classes.root, 'footer')}>
      <nav className="footer__nav">
        <div className={cn(classes.top, 'footer__top')}>
          <Menu
            className="footer__top-item"
            Header={
              <Link
                className={classes.underlineContainer}
                color="Emphasized"
                to={Routes.LegalPrivacyPolicy}
              >
                <Typography color="Emphasized" size={22}>
                  {t('legalInformation')}
                </Typography>
              </Link>
            }
          >
            <MenuItem onClick={() => history.push(Routes.LegalEula)} button>
              {t('termsOfUse')}
            </MenuItem>
            <MenuItem
              onClick={() => history.push(Routes.LegalPrivacyPolicy)}
              button
            >
              {t('privacyPolicy')}
            </MenuItem>
          </Menu>
          <ButtonRestyled
            className="footer__top-item"
            variant="transparent"
            onClick={() => history.push(Routes.Promo)}
          >
            <Typography size={22}>{t('promotionsAndNews')}</Typography>
          </ButtonRestyled>
          <ButtonRestyled
            className="footer__top-item"
            variant="transparent"
            onClick={() => history.push(Routes.Contacts)}
          >
            <Typography size={22}>{t('contacts')}</Typography>
          </ButtonRestyled>
          <SocialNetworks />
        </div>

        <RegistrationInfo />

        <div className={classes.support}>
          <Typography size={12} color="Emphasized" weight="lighter">
            {t('disclaimer')}
          </Typography>

          <Typography size={12} color="Emphasized" weight="lighter">
            {t('allQuestionsAndRequests')}
          </Typography>
        </div>

        <div
          className={cn(
            classes.payment,
            'footer__payments',
            isEnglish && classes.payment_eng
          )}
        >
          <img alt="master card" src={ImgMasterCard} width="41" height="32" />
          <img alt="visa" src={ImgVisa} width="73" height="32" />
          {isEnglish && (
            <a
              href="https://e-vouchers.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="visa" src={imgFindexiq} width="120" height="32" />
            </a>
          )}

          {!isEnglish && (
            <>
              <img alt="mir" src={ImgMir} width="83" height="32" />
              <img alt="web money" src={ImgWebMoney} width="87" height="32" />
              <img alt="qiwi" src={ImgQiwi} width="72" height="32" />
              <img alt="yoomoney" src={ImgYooMoney} width="153" height="32" />
              <img alt="payu" src={Payu} height="32" width="64" />
            </>
          )}
        </div>
      </nav>
    </footer>
  )
}

export default Footer
